/**
 * A way to globally use the same date format when using the useDateFormat composable.
 * If new date formats are required, they can be added here too, to ensure consistency.
 */

export enum DATE_FORMAT {
  DEFAULT = 'MMMM D, YYYY',
}
